module.exports = __webpack_public_path__ + "media/images/lift-elevator-1-e6262de01b30f974fcf8e5c9094bcba4.jpg";